<a
  class="flex cursor-pointer items-center justify-between rounded-1 px-xs py-2xs outline-president-200 hover:bg-grey-50 active:outline"
  [routerLink]="link"
>
  <span [class.truncate]="truncateLabel">{{ label }}</span>
  <fa-icon [icon]="icon" class="text-grey-500"></fa-icon>
</a>
